import React from 'react';
import Paper from "@mui/material/Paper";
import styled from "styled-components";
import Sensor from "./Sensor";
import {colors} from "../../maps/colors";
import AlertSettingsDisplay from "./AlertSettingsDisplay";

const FieldStyled = styled.div`
    padding: 10px;
`;

const FieldDataStyled = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
`;

const LabelStyled = styled.span`
    font-size: 11px;
    color: ${colors.BLACK_LIGHT};
    font-weight: 300;
`;

const SensorsWrapperStyled = styled.div`

`;

const Field = ({data, openAlerts, openSettingsHandle, site}) => {
    return (
        <Paper elevation={3}>
            <FieldStyled>
                <FieldDataStyled>
                    <div>
                        <LabelStyled>Name:</LabelStyled> {data.name}
                    </div>

                    <AlertSettingsDisplay
                        item={data}
                        siteSettings={site.alertSettings}
                        entType={"field"}
                        type={'Field Settings'}
                        openSettingsHandle={() => {
                            openSettingsHandle({data: data, type: 'field'});
                        }}
                    />
                </FieldDataStyled>
                <SensorsWrapperStyled>
                    {data?.shelves?.map((item, index) => {
                        const sensor = data?.sensorArr.find(sensor => sensor._id === item.sensorId);

                        return (
                            <Sensor
                                openAlerts={openAlerts}
                                key={index}
                                data={item}
                                field={data}
                                site={site}
                                sensor={sensor}
                                openSettingsHandle={() => {
                                    openSettingsHandle({data: item, type: 'sensor', field: data});
                                }}
                            />
                        );
                    })}
                </SensorsWrapperStyled>
            </FieldStyled>
        </Paper>
    );
};

export default Field;